import { 
  CheckmarkCircle16Regular, 
  DocumentEdit16Regular,
  Save16Regular,
  Clock16Regular,
  ArrowDownload16Regular,
  Checkmark16Regular,
  Circle16Regular,
  Settings16Regular,
  Search16Regular ,
  Wrench16Regular 
} from '@fluentui/react-icons';

export const getReportStatusConfig = (status) => {
    switch (status) {
      case 0:
        return {
          label: 'Unreported',
          className: 'unreported',
          icon: <Clock16Regular />
        };
      case 1:
        return {
          label: 'Preliminary',
          className: 'saved',
          icon: <DocumentEdit16Regular />
        };
      case 2:
        return {
          label: 'Reported',
          className: 'reported',
          icon: <CheckmarkCircle16Regular />
        };
      case 3:
        return {
          label: 'QC Review',
          className: 'qcReview',
          icon: <Settings16Regular  />
        };
      case 4:
        return {
          label: 'QC Fix',
          className: 'qcFix',
          icon: <Settings16Regular />
        };
      case 5:
        return {
          label: 'QC Verify',
          className: 'qcVerify',
          icon: <Wrench16Regular />
        };
      case 6:
        return {
          label: 'Saved',
          className: 'draft',
          icon: <Save16Regular />
        };
      case 7:
        return {
          label: 'Preliminary QC Review',
          className: 'qcReview',
          icon: <Settings16Regular  />
        };
      case 8:
        return {
          label: 'Preliminary QC Fix',
          className: 'qcFix',
          icon: <Settings16Regular />
        };
      case 9:
        return {
          label: 'Preliminary QC Verify',
          className: 'qcVerify',
          icon: <Wrench16Regular />
        };
      default:
        return {
          label: 'Processing',
          className: 'processing',
          icon: <Settings16Regular />
        };
    }
  };

export const getPreloadIcon = (prefetchStatus) => {
      switch (prefetchStatus) {
        case 'pending':
          return <Circle16Regular className="preload-pending" />;
        case 'loading':
          return <ArrowDownload16Regular className="preload-loading" />;
        case 'completed':
          return <Checkmark16Regular className="preload-completed" />;
        default:
          return null;
      }
    };
  
export const getPreloadTooltip = (prefetchStatus) => {
      switch (prefetchStatus) {
        case 'pending':
          return 'Preload: Not started';
        case 'loading':
          return 'Preload: In progress';
        case 'completed':
          return 'Preload: Complete';
        default:
          return 'Preload status unknown';
      }
    };
  
export const getAIDetectionConfig = (aiProcessed, maxAiEmergency) => {
    if(aiProcessed && aiProcessed == 0){
        return null;
    }

    if(aiProcessed && aiProcessed == 2){
       return {
            label: 'AI: Processing',
            className: 'ai-pending',
            text: 'AI',
            animate: true
        }; 
    }

    if(aiProcessed && aiProcessed == 1 &&
        maxAiEmergency && (maxAiEmergency == 0 || maxAiEmergency == 1)
    ){
        return {
            label: 'AI: Normal',
            className: 'ai-normal',
            text: 'AI'
        };
    }

    if(aiProcessed && aiProcessed == 1 &&
        maxAiEmergency && maxAiEmergency !== 0 && maxAiEmergency !== 1
    ){
        return {
            label: 'AI: Abnormal',
            className: 'ai-abnormal',
            text: 'AI'
        };
    }

    return null;

    //   switch (aiDetection) {
    //     case 'normal':
    //       return {
    //         label: 'AI: Normal',
    //         className: 'ai-normal',
    //         text: 'AI'
    //       };
    //     case 'abnormal':
    //       return {
    //         label: 'AI: Abnormal',
    //         className: 'ai-abnormal',
    //         text: 'AI'
    //       };
    //     case 'pending':
    //       return {
    //         label: 'AI: Processing',
    //         className: 'ai-pending',
    //         text: 'AI',
    //         animate: true
    //       };
    //     default:
    //       return null;
    //   }
    };